import { Button, SplitButton } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { useFetch } from '@frontend/utils/hooks/useFetch';

interface AddOrDeactivatePractitionerButtonProps {
    onClickAddPractitioner(): void;
    onClickDeactivatePractitioner(): void;
    organizationId: string;
}

export function AddOrDeactivatePractitionerButton(props: Readonly<AddOrDeactivatePractitionerButtonProps>) {
    const translate = getSelectedLanguage();

    const [fetchState] = useFetch<{ hasActiveEmployments: boolean }>(
        `/api/organizations/${props.organizationId}/hasActiveEmployments`
    );

    return (
        <>
            {fetchState.isFetching ? (
                <Button isLoading={true} />
            ) : (
                <>
                    {fetchState.responseData?.hasActiveEmployments ? (
                        <SplitButton
                            items={[
                                {
                                    label: translate.practitioner.add,
                                    onClick: props.onClickAddPractitioner,
                                },
                                {
                                    label: translate.practitioner.remove,
                                    onClick: props.onClickDeactivatePractitioner,
                                },
                            ]}
                        />
                    ) : (
                        <Button onClick={props.onClickAddPractitioner}>{translate.practitioner.add}</Button>
                    )}
                </>
            )}
        </>
    );
}
